<template>
  <div>
    <component :is="homeConponent" v-if="homeConponent == 'HomeYfh'"></component>
    <nuxt />
    <FooterYfh v-if="homeConponent == 'HomeYfh'"></FooterYfh>
    <OnlineServe v-if="['yfh'].includes(webInfo.id)"></OnlineServe>
  </div>
</template>

<script>
import HomeYfh from "@components/sys/header-yfh";
import PAGE_MIXIN from "@mixins/page.js";
import FooterYfh from "@components/sys/footer-yfh";
import OnlineServe from './online-serve.vue';
export default {
  mixins: [PAGE_MIXIN],
  data() {
    return {
      homeConponent: "HomeYfh",
    };
  },
  components: {
    HomeYfh,
    FooterYfh,
    OnlineServe
  },
  //   asyncData({ req, store }) {
  //     /**
  //      * 根据不同来源，渲染不同首页
  //      * 默认使用bht首页
  //      */
  //     var homeConponent = "HomeBht";

  //     if (store.state.webInfo && store.state.webInfo.webStyle) {
  //         console.log(store.state.webInfo.webStyle)
  //       homeConponent = store.state.webInfo.webStyle;
  //     }

  //     return {
  //       homeConponent,
  //     };
  //   },
};
</script>
<style lang="scss" scoped></style>
